import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import PaymentLineItem from "../Payments/PaymentLineItem";
import CustomSidePanel from "../common/CustomSidePanel";
import PaymentInfoSidePanel from "../PaymentInfoSidePanel";

const PageWrapper = styled.div`
  
`;

const PageContent = styled.div`
    padding-left: 48px;
    padding-top: 84px;
`;

const paymentsTestData = [
    {
        id: "CO12413",
        nextPayment: "Nov 28, 2019",
        paymentDue: "$ 438,971.68",
        totalBalance: "$ 3,338,971.68",
        status: "",
        payments: [
           {
               date: "",
               paymentDue:"",
               status: "",
           }
        ],
        contract: {
            id: "C068321",
            status: "Signed - Inactive",
            planDuration: "3 months",
            companyName: "Ajaccio Investments Limited’s",
            totalCashPrice: "$ 3,338,971.68",
            monthlyPayment: "$ 438,971.68",
            dateSigned: "Oct 21, 2019",
            deliveryEstimate: "Nov 4, 2019",
            lastUpdated: "Oct 23, 2019",
        }
    }
];

const testContracts = [
    {
        id: "C068321",
        status: "Signed - Inactive",
        planDuration: "3 months",
        companyName: "Ajaccio Investments Limited’s",
        totalCashPrice: "$ 3,338,971.68",
        monthlyPayment: "$ 438,971.68",
        dateSigned: "Oct 21, 2019",
        deliveryEstimate: "Nov 4, 2019",
        lastUpdated: "Oct 23, 2019",
    },
    {
        id: "C068134",
        status: "Signed - Inactive",
        companyName: "Ajaccio Investments Limited’s",
        planDuration: "4 months",
        totalCashPrice: "$ 3,338,971.68",
        monthlyPayment: "$ 68,971.68",
        dateSigned: "Oct 21, 2019",
        deliveryEstimate: "Nov 4, 2019",
        lastUpdated: "Oct 23, 2019",
    },
];

function ProfilePayments(props) {

    const payments = paymentsTestData;
    const [selectedItem, setSelectedItem] = useState();
    const [openDrawer, setOpenDrawer] = useState(false);


    const handlePaymentSelect = (paymentItem) => {
        setSelectedItem(paymentItem);
        setOpenDrawer(true);
    };

    return (
        <PageWrapper>

            <PageContent>
                {
                    payments.map(item =>
                        <PaymentLineItem {...item}
                                         contractId={item.id}
                                         status={"payment due"}
                                         onMoreBtnClick={() => {
                                             handlePaymentSelect(item)
                                         }}
                                         onContractIdClick={ () => {
                                             handlePaymentSelect(item)
                                         }}
                        />)
                }
            </PageContent>



        {/* View Payment */}

        <CustomSidePanel open={openDrawer} onDrawerClose={() => {setOpenDrawer(false);}}>

            {
                <PaymentInfoSidePanel />

            }
        </CustomSidePanel>


        </PageWrapper>
    );
}

ProfilePayments.propTypes = {};
ProfilePayments.defaultProps = {};

export default ProfilePayments;
